import { FC } from "react";
import FormInput from "../FormInput";
import useFormsStore from "../../store/formValuesStore";
import { useTranslation } from "react-i18next";

const FourthForm: FC = () => {
  const { values, setValue } = useFormsStore();
  const handleChange = (value: string) => {
    setValue(4, value);
  };
  const { t } = useTranslation();

  return (
    <div>
      <FormInput
        value={values[4].value}
        onChangeText={handleChange}
        label={t("questions.5")}
      />
    </div>
  );
};

export default FourthForm;
